"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LaptopStar: ['laptop-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.6,15.485a.25.25,0,0,0-.144-.3,2.368,2.368,0,0,1-1.407-1.337.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.437a.249.249,0,0,0,.205-.107.251.251,0,0,0,.03-.23A2.727,2.727,0,0,1,9.6,15.485Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.543a.221.221,0,0,0,.131.2,2.726,2.726,0,0,1,1.409,1.4.239.239,0,0,0,.458-.081c0-.02,0-.039,0-.059V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M23.609,17.139a1.264,1.264,0,0,0,.3-1.378A1.233,1.233,0,0,0,22.74,15h-2.5a.249.249,0,0,1-.229-.151l-1.344-3.116-.013-.028a1.294,1.294,0,0,0-2.318.028L14.99,14.848a.25.25,0,0,1-.23.151h-2.5a1.228,1.228,0,0,0-1.166.76,1.268,1.268,0,0,0,.319,1.4l2.194,1.955a.252.252,0,0,1,.063.287l-1.223,2.814a1.253,1.253,0,0,0,.314,1.451,1.278,1.278,0,0,0,1.506.166l3.112-1.752a.249.249,0,0,1,.245,0l3.113,1.752a1.273,1.273,0,0,0,1.506-.166,1.254,1.254,0,0,0,.315-1.45L21.334,19.4a.251.251,0,0,1,.063-.287Z']],
  LaptopRefresh: ['laptop-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.492,15.207A2.368,2.368,0,0,1,8.051,13.86a.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.047a.25.25,0,0,0,.249-.23,7.71,7.71,0,0,1,.339-1.756A.25.25,0,0,0,9.492,15.207Z', 'M3.5,12.01a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.922a.249.249,0,0,0,.2.245,7.668,7.668,0,0,1,1.453.439.25.25,0,0,0,.346-.231V3.01a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12.01Z', 'M23.692,11.56a.5.5,0,0,0-.545.108l-1.3,1.3a.249.249,0,0,1-.348.005A6.374,6.374,0,1,0,22.13,21.6a1,1,0,0,0-1.562-1.248,4.376,4.376,0,1,1-.5-5.982.251.251,0,0,1,.082.18.248.248,0,0,1-.073.183l-1.391,1.39a.5.5,0,0,0,.354.854H23.5a.5.5,0,0,0,.5-.5V12.022A.5.5,0,0,0,23.692,11.56Z']],
  LaptopAdd: ['laptop-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.466.466,0,0,0-.05.469,5.431,5.431,0,0,0,5,3.311H9.255a.25.25,0,0,0,.249-.243,7.83,7.83,0,0,1,.245-1.713A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.905,7.905,0,0,1,1.454.37.247.247,0,0,0,.228-.03.25.25,0,0,0,.107-.2V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.5h-1.25a.25.25,0,0,0-.25.25V20a1,1,0,0,1-2,0v-1.25a.25.25,0,0,0-.25-.25H15a1,1,0,0,1,0-2h1.25a.25.25,0,0,0,.25-.25V15a1,1,0,0,1,2,0v1.25a.25.25,0,0,0,.25.25H20a1,1,0,0,1,0,2Z']],
  LaptopCash: ['laptop-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.95,10.2a.249.249,0,0,0-.2.245v.308a.75.75,0,0,1-1.5,0V21.5a.25.25,0,0,0-.25-.25H16a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.221-1.141l-2.065-.826a2.085,2.085,0,0,1,.36-3.981.249.249,0,0,0,.2-.244v-.308a.75.75,0,0,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.968a.591.591,0,0,0-.221,1.14l2.064.826a2.084,2.084,0,0,1-.36,3.981Z']],
  LaptopClock: ['laptop-clock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11A4.5,4.5,0,1,1,22,17.5,4.5,4.5,0,0,1,17.5,22Z', 'M19.5,16.751h-1a.25.25,0,0,1-.25-.25v-2a.75.75,0,0,0-1.5,0v3a.75.75,0,0,0,.75.75h2a.75.75,0,0,0,0-1.5Z']],
  LaptopDisable: ['laptop-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.719,15.363a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.626a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.38a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.719,15.363Z', 'M3.626,12.126a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.469a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3.126a3.009,3.009,0,0,0-3-3h-12a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.626,12.126Z', 'M17.626,11.376a6.25,6.25,0,1,0,6.25,6.25A6.256,6.256,0,0,0,17.626,11.376Zm-3.6,8.289a.247.247,0,0,1-.184-.133,4.16,4.16,0,0,1-.467-1.906,4.254,4.254,0,0,1,4.25-4.25,4.167,4.167,0,0,1,1.907.467.251.251,0,0,1,.063.4L14.242,19.6A.245.245,0,0,1,14.027,19.665Zm3.6,2.211a4.167,4.167,0,0,1-1.907-.467.251.251,0,0,1-.063-.4l5.353-5.352a.248.248,0,0,1,.216-.07.251.251,0,0,1,.184.133,4.16,4.16,0,0,1,.467,1.906A4.255,4.255,0,0,1,17.626,21.876Z']],
  LaptopDownload: ['laptop-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.39,7.062-2,2.5a.5.5,0,0,1-.781,0l-2-2.5a.5.5,0,0,1,.391-.812h.75A.25.25,0,0,0,16.5,17v-2.75a1,1,0,0,1,2,0V17a.25.25,0,0,0,.25.25h.75a.5.5,0,0,1,.39.812Z']],
  LaptopSearch: ['laptop-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.437,15.178a2.339,2.339,0,0,1-1.386-1.327.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.285a.249.249,0,0,0,.186-.083.246.246,0,0,0,.063-.193,6.668,6.668,0,0,1-.033-.684,6.784,6.784,0,0,1,.085-1.083A.251.251,0,0,0,9.437,15.178Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.606a.249.249,0,0,0,.173.238,6.929,6.929,0,0,1,1.449.654.251.251,0,0,0,.378-.215V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M23.708,22.294l-2.483-2.483a.248.248,0,0,1-.033-.311A5.54,5.54,0,1,0,19.5,21.192a.251.251,0,0,1,.311.033l2.483,2.483a1,1,0,0,0,1.414-1.414Zm-7.177-2.233a3.53,3.53,0,1,1,3.53-3.53A3.529,3.529,0,0,1,16.531,20.061Z']],
  LaptopSubtract: ['laptop-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.5H15a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z']],
  LaptopUpload: ['laptop-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm2.45,6.466a.5.5,0,0,1-.45.284h-.75a.25.25,0,0,0-.25.25v2.75a1,1,0,0,1-2,0V18a.25.25,0,0,0-.25-.25H15.5a.5.5,0,0,1-.391-.813l2-2.5a.519.519,0,0,1,.781,0l2,2.5A.5.5,0,0,1,19.951,17.467Z']],
  LaptopShare: ['laptop-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.142,15.4a2.737,2.737,0,0,1-2.091-1.552.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.367a.249.249,0,0,0,.244-.194,4.179,4.179,0,0,1,.68-1.5.25.25,0,0,0-.149-.391Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v7.02a.25.25,0,0,0,.391.206,4.082,4.082,0,0,1,1.414-.617.251.251,0,0,0,.2-.244V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M21.251,18.5a2.725,2.725,0,0,0-1.887.76.251.251,0,0,1-.266.052l-2.445-.979a.25.25,0,0,1-.157-.214c0-.044-.008-.1-.017-.165a.25.25,0,0,1,.119-.247l2.84-1.7a.251.251,0,0,1,.27.008,2.7,2.7,0,0,0,1.543.488,2.75,2.75,0,1,0-2.75-2.75,2.214,2.214,0,0,0,.021.295.25.25,0,0,1-.119.247L15.564,16a.251.251,0,0,1-.271-.009,2.708,2.708,0,0,0-1.542-.487,2.75,2.75,0,1,0,1.887,4.739.251.251,0,0,1,.265-.051L18.48,21.22a.034.034,0,0,1,.021.031,2.75,2.75,0,1,0,2.75-2.75Z']],
  LaptopBug: ['laptop-bug', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.319,16.468a.25.25,0,0,0-.084-.269c-.236-.187-.484-.391-.616-.523a.247.247,0,0,0-.206-.072,3.564,3.564,0,0,1-.412.021,3.1,3.1,0,0,1-2.95-1.649.493.493,0,0,0-.47-.361H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31h5.211a.251.251,0,0,0,.2-.1,2.046,2.046,0,0,1,1.646-.87A.249.249,0,0,0,12.319,16.468Z', 'M3.5,12.125a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v8a1,1,0,0,0,2,0v-8a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v8A1,1,0,0,0,3.5,12.125Z', 'M23.251,18.125H21a.249.249,0,0,1-.25-.25v-.75a2.7,2.7,0,0,0-.075-.607.25.25,0,0,1,.088-.251l1.954-1.554a.75.75,0,1,0-.934-1.174L20.07,14.9a.249.249,0,0,1-.322-.01,2.985,2.985,0,0,0-4,0,.25.25,0,0,1-.322.01l-1.713-1.363a.75.75,0,0,0-.934,1.174l1.953,1.553a.25.25,0,0,1,.088.252,2.7,2.7,0,0,0-.074.607v.75a.249.249,0,0,1-.25.25h-2.25a.75.75,0,1,0,0,1.5H14.5a.25.25,0,0,1,.25.25v.25a2.7,2.7,0,0,0,.075.608.251.251,0,0,1-.089.252l-1.953,1.554a.75.75,0,0,0,.934,1.174l1.713-1.363a.251.251,0,0,1,.323.009,2.986,2.986,0,0,0,3.994,0,.25.25,0,0,1,.322-.009l1.714,1.363a.75.75,0,1,0,.934-1.174l-1.954-1.554a.248.248,0,0,1-.088-.252,2.7,2.7,0,0,0,.075-.608v-.25a.25.25,0,0,1,.25-.25h2.25a.75.75,0,1,0,0-1.5Z']],
  LaptopApprove: ['laptop-approve', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.474,5.354L18.07,20.229a1.742,1.742,0,0,1-1.275.7c-.042,0-.084,0-.126,0a1.745,1.745,0,0,1-1.24-.516l-1.5-1.5A1,1,0,1,1,15.344,17.5l1.1,1.094a.246.246,0,0,0,.194.072.25.25,0,0,0,.183-.1l2.558-3.412a1,1,0,0,1,1.6,1.2Z']],
  LaptopHeart: ['laptop-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.542,15.426a.248.248,0,0,0-.143-.259A2.382,2.382,0,0,1,8.05,13.851a.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.431,5.431,0,0,0,5,3.31H9.39a.248.248,0,0,0,.2-.1.252.252,0,0,0,.046-.214A4.765,4.765,0,0,1,9.542,15.426Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v7.75a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M23.628,14.45a3.526,3.526,0,0,0-5.646-.916l-.3.3a.25.25,0,0,1-.353,0l-.305-.3a3.525,3.525,0,0,0-4.993,4.977l5.114,5.335a.5.5,0,0,0,.721,0l5.107-5.327A3.522,3.522,0,0,0,23.628,14.45Z']],
  LaptopQuestion: ['laptop-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.344a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.5Zm.912-4.163a.25.25,0,0,0-.162.234v.18a.75.75,0,0,1-1.5,0V18.2a1.257,1.257,0,0,1,.986-1.222,1.125,1.125,0,1,0-1.361-1.1.75.75,0,1,1-1.5,0,2.625,2.625,0,1,1,3.537,2.461Z']],
  LaptopEdit: ['laptop-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.745,17.427l3.51-3.51a.25.25,0,0,0-.177-.426h-.646a.5.5,0,0,0-.48.36c-.28.94-1.62,1.65-2.95,1.65a3.082,3.082,0,0,1-2.95-1.65.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31l6.526.01A.252.252,0,0,0,11.745,17.427Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v7.126a.25.25,0,0,0,.4.2,4.106,4.106,0,0,1,1.413-.682A.25.25,0,0,0,20.5,9.4V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M12.74,20.047a.5.5,0,0,0-.834.215l-.886,3.1A.5.5,0,0,0,11.5,24a.459.459,0,0,0,.137-.02l3.1-.886a.5.5,0,0,0,.216-.834Z', 'M18.772,13.229a.5.5,0,0,0-.707,0L13.054,18.24a.5.5,0,0,0,0,.707l3,3a.5.5,0,0,0,.708,0l5.01-5.011a.5.5,0,0,0,0-.707Z', 'M23.233,11.768a2.643,2.643,0,0,0-3.754.047.5.5,0,0,0,0,.707l3,3a.457.457,0,0,0,.328.125.612.612,0,0,0,.426-.172A2.624,2.624,0,0,0,23.233,11.768Z']],
  LaptopFlash: ['laptop-flash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.589,15.265a4.007,4.007,0,0,1-1.338.236,3.1,3.1,0,0,1-2.95-1.65.492.492,0,0,0-.47-.36H.751a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31h6.716a.25.25,0,0,0,.18-.077.253.253,0,0,0,.07-.183,2.394,2.394,0,0,1,.564-1.64.208.208,0,0,0-.232-.326Z', 'M3.751,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v4.63a.249.249,0,0,0,.389.207,1.974,1.974,0,0,1,1.331-.323.25.25,0,0,0,.28-.248V3a3.009,3.009,0,0,0-3-3h-12a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.751,12Z', 'M23.67,15.508A.879.879,0,0,0,22.876,15H21a.25.25,0,0,1-.25-.25V9.5a.5.5,0,0,0-.89-.313l-5.9,7.37A.876.876,0,0,0,14.626,18H16.5a.25.25,0,0,1,.25.25V23.5a.5.5,0,0,0,.334.471.48.48,0,0,0,.166.029.5.5,0,0,0,.39-.188l5.9-7.37A.877.877,0,0,0,23.67,15.508Z']],
  LaptopLock2: ['laptop-lock-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.221,15.3a3.981,3.981,0,0,1-1.22.2,3.082,3.082,0,0,1-2.95-1.65.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31l7.209.009a.251.251,0,0,0,.251-.25V16a1.95,1.95,0,0,1,.042-.409.25.25,0,0,0-.322-.289Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V8.757a.25.25,0,0,0,.264.25C18.843,9,18.922,9,19,9a5.227,5.227,0,0,1,1.193.139A.251.251,0,0,0,20.5,8.9V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M22.715,15.516a.25.25,0,0,1-.214-.248V14.251a3.5,3.5,0,0,0-7,0v1.017a.251.251,0,0,1-.214.248A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.715,15.516ZM19,21.251a1,1,0,1,1,1-1A1,1,0,0,1,19,21.251Zm1.5-6a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25v-1a1.5,1.5,0,0,1,3,0Z']],
  LaptopRemove: ['laptop-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.594,15.238a2.428,2.428,0,0,1-1.543-1.387.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.255a.249.249,0,0,0,.249-.242,7.839,7.839,0,0,1,.245-1.714A.25.25,0,0,0,9.594,15.238Z', 'M3.5,12a1,1,0,0,0,1-1V3a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1v6.37a.218.218,0,0,0,.185.216,7.829,7.829,0,0,1,1.48.375.251.251,0,0,0,.335-.236V3a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1.591,6.676,1.237,1.238a1,1,0,1,1-1.414,1.414l-1.238-1.238a.25.25,0,0,0-.353,0l-1.237,1.238a1,1,0,1,1-1.414-1.414l1.237-1.238a.25.25,0,0,0,0-.353l-1.237-1.237a1,1,0,1,1,1.414-1.414l1.237,1.237a.249.249,0,0,0,.353,0l1.238-1.237a1,1,0,1,1,1.414,1.414l-1.237,1.237A.249.249,0,0,0,19.092,17.677Z']],
  LaptopSettings: ['laptop-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.277,15.132a2.244,2.244,0,0,1-1.218-1.25.492.492,0,0,0-.47-.36H.509a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.431,5.431,0,0,0,5,3.31H9.011a.251.251,0,0,0,.25-.254c0-.081,0-.162,0-.246A8.909,8.909,0,0,1,9.412,15.4.25.25,0,0,0,9.277,15.132Z', 'M3.509,12.032a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V8.326a.249.249,0,0,0,.222.248,8.216,8.216,0,0,1,1.455.3.25.25,0,0,0,.323-.239v-5.6a3.009,3.009,0,0,0-3-3h-12a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.509,12.032Z', 'M16.240 17.001 A1.500 1.500 0 1 0 19.240 17.001 A1.500 1.500 0 1 0 16.240 17.001 Z', 'M22.521,17.314a.462.462,0,0,1,0-.626l.987-1.064a1.782,1.782,0,0,0-1.7-2.953L20.4,13a.457.457,0,0,1-.534-.312L19.44,11.3a1.775,1.775,0,0,0-3.4,0l-.425,1.391a.452.452,0,0,1-.533.312l-1.411-.327a1.783,1.783,0,0,0-1.7,2.953l.988,1.064a.462.462,0,0,1,0,.626l-.988,1.065a1.783,1.783,0,0,0,1.7,2.953l1.412-.327a.453.453,0,0,1,.532.31l.425,1.393a1.745,1.745,0,0,0,1.7,1.261h0a1.747,1.747,0,0,0,1.7-1.261l.423-1.393a.449.449,0,0,1,.534-.31l1.411.327a1.783,1.783,0,0,0,1.7-2.953ZM17.74,20a3,3,0,1,1,3-3A3,3,0,0,1,17.74,20Z']],
  LaptopSync: ['laptop-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.719,15.289A2.492,2.492,0,0,1,8.051,13.86a.492.492,0,0,0-.47-.36H.5a.478.478,0,0,0-.41.22.467.467,0,0,0-.05.47,5.43,5.43,0,0,0,5,3.31H9.288a.25.25,0,0,0,.249-.228A7.559,7.559,0,0,1,9.878,15.6.25.25,0,0,0,9.719,15.289Z', 'M3.5,12.01a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.853a.249.249,0,0,0,.211.247,7.828,7.828,0,0,1,1.454.371.247.247,0,0,0,.228-.031.25.25,0,0,0,.107-.2V3.01a3.009,3.009,0,0,0-3-3H5.5a3.009,3.009,0,0,0-3,3v8A1,1,0,0,0,3.5,12.01Z', 'M22.77,18.6a1,1,0,0,0-1.27.622,4.091,4.091,0,0,1-6.918,1.42.25.25,0,0,1,.008-.345l1.721-1.721a.5.5,0,0,0-.353-.854H11.5a.5.5,0,0,0-.5.5V22.68a.5.5,0,0,0,.853.353l.97-.969a.251.251,0,0,1,.359,0,6.085,6.085,0,0,0,10.209-2.2A1,1,0,0,0,22.77,18.6Z', 'M23.692,11.773a.5.5,0,0,0-.545.108l-1.025,1.026a.251.251,0,0,1-.358,0,6.1,6.1,0,0,0-10.195,2.226,1,1,0,1,0,1.892.649,4.09,4.09,0,0,1,6.9-1.445.249.249,0,0,1-.006.346l-1.66,1.659a.5.5,0,0,0,.354.854H23.5a.5.5,0,0,0,.5-.5V12.235A.5.5,0,0,0,23.692,11.773Z']],
  LaptopWarning: ['laptop-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.5,12.251a1,1,0,0,0,1-1v-8a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V9.775a.251.251,0,0,0,.153.231,2.9,2.9,0,0,1,1.458,1.319l.01.019a.2.2,0,0,0,.227.1.2.2,0,0,0,.152-.2v-8a3,3,0,0,0-3-3H5.5a3,3,0,0,0-3,3v8A1,1,0,0,0,3.5,12.251Z', 'M23.838,21.656l-5.055-9.634a1.45,1.45,0,0,0-2.562,0l-5.056,9.634a1.429,1.429,0,0,0,.048,1.408,1.453,1.453,0,0,0,1.233.687H22.558a1.455,1.455,0,0,0,1.232-.687A1.429,1.429,0,0,0,23.838,21.656Zm-7.087-6.4a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0ZM17.5,22a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22Z', 'M11.594,17.611l.887-1.691a.25.25,0,0,0-.3-.355A3.947,3.947,0,0,1,11,15.751,3.078,3.078,0,0,1,8.054,14.1a.5.5,0,0,0-.479-.356H.5a.5.5,0,0,0-.465.685A5.446,5.446,0,0,0,5.04,17.743l6.332,0A.251.251,0,0,0,11.594,17.611Z']]
};
exports["default"] = _default;